import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, VideoCameraIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { usePageMeta } from '../../hooks/usePageMeta';
import V2Nav from '../../components/homepage-v2/V2Nav';
import { FooterSection } from '../../components/homepage-v2';
import '../../components/homepage-v2/homepageV2.css';
import CalendlyEmbed, { CALENDLY_DEMO_URL, calendlyEmbedUrl } from '../../components/CalendlyEmbed';

const FACTS = [
  {
    icon: ClockIcon,
    title: '30 minutes',
    body: 'A short walkthrough, not a webinar.',
  },
  {
    icon: VideoCameraIcon,
    title: 'Zoom',
    body: 'You’ll get a calendar invite with the link.',
  },
  {
    icon: ChatBubbleLeftRightIcon,
    title: 'No pitch',
    body: 'Ask about your workflow. Skip it if it isn’t a fit.',
  },
];

export default function BookDemo() {
  usePageMeta(
    'Book a free demo | SmileConsent',
    'Book a short demo of SmileConsent — AI-assisted dental consent drafting with clinician review, digital signing, and workflows tailored to your practice.',
    'https://smileconsent.co.uk/book-demo'
  );

  return (
    <div className="hpv2 min-h-screen flex flex-col">
      <V2Nav />

      <main className="hpv2-book flex-1">
        <div className="hpv2-container">
          <header className="hpv2-book-head">
            <p className="hpv2-eyebrow">Free practice demo</p>
            <h1 className="hpv2-display">Book a time that suits you</h1>
            <p>
              We’ll show how UK practices draft consent, send it for signature, and keep a clearer record.
              Pick a slot — you’ll get a Zoom invite straight away.
            </p>
          </header>

          <ul className="hpv2-book-facts">
            {FACTS.map(({ icon: Icon, title, body }) => (
              <li key={title}>
                <span className="hpv2-book-fact-icon" aria-hidden="true">
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <strong>{title}</strong>
                  <span>{body}</span>
                </div>
              </li>
            ))}
          </ul>

          <div className="hpv2-book-card">
            <div className="book-demo-calendly">
              <CalendlyEmbed
                url={calendlyEmbedUrl(CALENDLY_DEMO_URL)}
                minHeight="700px"
              />
            </div>
          </div>

          <p className="hpv2-book-fallback">
            Can&apos;t see the calendar?{' '}
            <a href={CALENDLY_DEMO_URL} target="_blank" rel="noopener noreferrer">
              Open booking in a new tab
            </a>
            {' · '}
            <Link to="/privacy">Privacy notice</Link>
          </p>
        </div>
      </main>

      <FooterSection />
    </div>
  );
}
